import { Typography, WithChildrenCommonProps } from '@shipengine/giger';
import { getLogoStyles, getOnboardingPlatformsCardStyles, getTextStyles } from './OnboardingPlatformsCardStyles';

export type OnboardingPlatformsCardProps = {
    isSelected: boolean;
    logoUrl?: string;
    name?: string;
    alias: string;
    onClick: (alias: string, isSelected: boolean) => void;
};

export function OnboardingPlatformsCard({
    isSelected,
    logoUrl,
    name,
    children,
    alias,
    onClick,
    ...rest
}: WithChildrenCommonProps<OnboardingPlatformsCardProps>): JSX.Element {
    const displayName = !children && !logoUrl && name;

    return (
        <div
            onClick={() => onClick(alias, isSelected)}
            role="checkbox"
            css={getOnboardingPlatformsCardStyles(isSelected)}
            aria-label={name}
            aria-checked={isSelected}
            {...rest}
        >
            {logoUrl && <img css={getLogoStyles} alt={name} src={logoUrl} />}
            {displayName && (
                <Typography css={getTextStyles} variant="body2" bold>
                    {name}
                </Typography>
            )}

            {children}
        </div>
    );
}
